import "./divider.css";

function Divider() {
    return <div className="divider">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3808.971 589.117">
            <g id="Divider" data-name="Divider" transform="translate(26.274 -81.998)">
                <path id="Pfad_1" data-name="Pfad 1" d="M4373.439,2260.913s331.358,142.5,633.53,90.995,374.509-109.082,704.774-160.06c360.552-55.652,585.54-18.075,939.907-79.911C6971.644,2056.1,7231,1934.016,7581.8,1904.485s551.642,0,551.642,0" transform="translate(-4373.439 -1739.482)" fill="none" stroke="var(--color-1)" stroke-linecap="round" stroke-width="40"/>
                <path id="Pfad_2" data-name="Pfad 2" d="M2926.147,362.682S2571.6,600.4,2278,592.278s-476.155-88.446-664.764-60.565c-218.8,32.345-368.278,238.021-646.064,192.358S719.83,583.085,759.4,588.032,738.022,808.6,454.528,805.243C205.9,802.3-44.6,717.718-76.494,648.889s48.659-60.433,32.013,0-161.47,298.862-362.552,296.929c-274.7-2.641-428.929-269.525-428.929-269.525" transform="translate(835.561 -277.215)" fill="none" stroke="var(--color-2)" stroke-linecap="square" stroke-width="5"/>
            </g>
        </svg>

    </div>
}

export default Divider;